import { Controller } from 'stimulus';

class HeaderController extends Controller {
  connect() {
    this.isFixed = false;
    this.headerSpacer = document.querySelector('.js-header-spacer');

    this.checkHeaderOffsetAndScroll = () => {
      this.checkHeaderOffset();
      this.onWindowScroll();
    };

    this.checkHeaderOffsetAndScroll();

    window.addEventListener('resize', this.checkHeaderOffsetAndScroll.bind(this));
    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener('resize', this.checkHeaderOffsetAndScroll.bind(this));
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
  }

  checkHeaderOffset() {
    const windowHeaderOffset = this.headerSpacer.getBoundingClientRect().top;
    const windowScroll = window.scrollY;

    this.headerOffset = windowHeaderOffset + windowScroll;
  }

  onWindowScroll() {
    const top = window.scrollY;

    if (top >= this.headerOffset && !this.isFixed) {
      this.isFixed = true;
      this.setFixedState();
    } else if (top < this.headerOffset && this.isFixed) {
      this.isFixed = false;
      this.setFixedState();
    }
  }

  setFixedState() {
    this.element.classList[this.isFixed ? 'add' : 'remove']('is-fixed');
  }
}

HeaderController.targets = [
  //
];

export default HeaderController;
